<div class="col-sm-12">
  <div class="col-sm-9 center-block mt-4">
    <div class="col-sm-12 error-div">
      <div class="col-sm-7 error-div-left">
        <div class="error-heading">{{title}}</div>
        <div class="col-sm-12 no-left-padding error-text">
          {{userMessage}}
        </div>
        <div class="col-sm-12 error-desc-div no-left-padding" *ngIf="devMode">
          {{devMessage}}
        </div>
      </div>
      <div class="col-sm-5 error-div-right">
        <i class="{{iconClass}} error-icon" aria-hidden="true"></i>
      </div>
    </div>
  </div>
